import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";

export const ReturnDetails = ({ returnOrder }) => {
  const address = {
    "No.": returnOrder.no,
    Branch: `${returnOrder.branchName} (${returnOrder.branchNo})`,
    Date: returnOrder.postingDate,
    Reference: returnOrder.returnRef,
    Package: `${returnOrder.packType} * ${returnOrder.packNo}`,
    Total: `£${returnOrder.amount || 0}`,
  };

  return (
    <Paper sx={{ p: 2 }}>
      <Typography variant="h6" gutterBottom>
        Details
      </Typography>
      <Grid
        container
        spacing={{ xs: 2, md: 2 }}
        columns={{ xs: 2, sm: 2, md: 3 }}
      >
        {Object.entries(address).map(([key, value], i) => (
          <Grid
            key={key}
            size={{
              xs: 1,
              sm: 1,
              md: 1,
            }}
          >
            <TextField
              size="small"
              fullWidth
              id={`${key}-input`}
              label={key}
              value={value || ""}
              slotProps={{
                input: {
                  readOnly: true,
                },
              }}
            />
          </Grid>
        ))}
      </Grid>
    </Paper>
  );
};
